import { createContext, useContext, useCallback, ReactNode } from "react";
import { useLocalStorageState } from "hooks/useLocalStorageState";

interface StatsContextType {
  statsOpen: boolean;
  handleToggle: () => void;
}

const StatsContext = createContext<StatsContextType | undefined>(undefined);

export function StatsProvider({ children }: { children: ReactNode }) {
  const [statsOpen, setStatsOpen] = useLocalStorageState<boolean>(
    "wasteStatsOpen",
    {
      defaultValue: true,
    }
  );

  const handleToggle = useCallback(() => {
    setStatsOpen((prevState) => !prevState);
  }, [setStatsOpen]);

  return (
    <StatsContext.Provider value={{ statsOpen, handleToggle }}>
      {children}
    </StatsContext.Provider>
  );
}

export function useStats() {
  const context = useContext(StatsContext);
  if (context === undefined) {
    throw new Error("useStats must be used within a StatsProvider");
  }
  return context;
}
